import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

/**
 * The Figma desktop `IconButton` that scrolls a horizontal row by one step
 * (the collections band, the chip bars of Explore): 32px with its border, a
 * 20px chevron.
 */
export function ScrollArrowButton({
  direction,
  onClick,
}: {
  direction: "previous" | "next";
  onClick: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      aria-label={direction === "previous" ? t("Previous") : t("Next")}
      onClick={onClick}
      className="flex shrink-0 cursor-pointer items-center justify-center rounded-lg border border-ds-slate-100 bg-ds-white p-1.25 text-ds-slate-900 hover:bg-ds-slate-50"
    >
      {direction === "previous" ? (
        <IconChevronLeft size={20} stroke={1.5} />
      ) : (
        <IconChevronRight size={20} stroke={1.5} />
      )}
    </button>
  );
}
